import { prefersReducedMotion,useLoopInView } from "@/4-components/animations/anime";
import { WF, WF_TOTAL, WfBar, WfColumn, WfLegend,WfLift } from "@/4-components/composites/waterfall";

import { BentoArt, bentoLoop } from "./BentoArt";

/**
 * EBITDA, the waterfall of `PnlRewrite`, in the tile that leads to it.
 * Same four columns: today's EBITDA (grey), the two contributions stacked on top of it
 * (GO saving · earnings on the sold energy) and the result column. On loop the bars grow
 * left→right, hold, then recede to the start.
 */
export function EbitdaMini() {
  const ref = useLoopInView<HTMLDivElement>((root) => {
    const bars = ["ew-now", "ew-go", "ew-rev", "ew-after"].map((c) => root.querySelector<HTMLElement>(`.${c}`));
    if (bars.some((b) => !b)) return;
    const [now, go, rev, after] = bars as HTMLElement[];

    if (prefersReducedMotion()) {
      for (const b of [now, go, rev, after]) b.style.transform = "scaleY(1)";
      return;
    }

    const tl = bentoLoop()
      // build the waterfall, one column at a time
      .add(now, { scaleY: [0, 1], duration: 700, ease: "outQuart" }, 300)
      .add(go, { scaleY: [0, 1], duration: 550, ease: "outQuart" }, 1200)
      .add(rev, { scaleY: [0, 1], duration: 550, ease: "outQuart" }, 1900)
      .add(after, { scaleY: [0, 1], duration: 900, ease: "outQuart" }, 2600)
      // hold on the result, then recede back to the start
      .add(after, { scaleY: [1, 0], duration: 600 }, 5200)
      .add(rev, { scaleY: [1, 0], duration: 500 }, 5400)
      .add(go, { scaleY: [1, 0], duration: 500 }, 5600)
      .add(now, { scaleY: [1, 0], duration: 600 }, 5800);

    return tl;
  });

  return (
    <BentoArt ref={ref} className="flex h-full flex-col justify-end">
      <div className="layout-waterfall-mini">
        <WfColumn>
          <WfBar cls="ew-now" h={WF.now} className="rounded-md bg-zinc-200" />
        </WfColumn>
        <WfColumn>
          <WfBar cls="ew-go" h={WF.go} className="rounded-md bg-dec-green/25 ring-1 ring-inset ring-dec-green/35" />
          <WfLift h={WF.now} />
        </WfColumn>
        <WfColumn>
          <WfBar cls="ew-rev" h={WF.rev} className="rounded-md bg-dec-green/25 ring-1 ring-inset ring-dec-green/35" />
          <WfLift h={WF.now + WF.go} />
        </WfColumn>
        <WfColumn>
          <WfBar cls="ew-after" h={WF_TOTAL} className="rounded-md bg-dec-green" />
        </WfColumn>
      </div>
      <WfLegend />
    </BentoArt>
  );
}
